import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import $ from "jquery";
import { Button, Navbar, Nav, Container, Row, Col } from 'react-bootstrap'
import { useStaticQuery, graphql } from "gatsby"

import HeaderMenu from "gatsby-theme-starberry-lomondgroup/src/components/Header/Sections/HeaderMenu"
import HeaderLogo from "./HeaderLogo"

import { defaultResult_Link} from "gatsby-theme-starberry-lomondgroup/src/common/constant";
import { PageLinks } from "gatsby-theme-starberry-lomondgroup/src/common/page-links";
import { menuLinks } from "gatsby-theme-starberry-lomondgroup/src/common/utils/page_url_utils";

// Images

const PrimaryHeader = (props) => {


  const [scroll, setScroll] = useState(false);

  useEffect(() => {

    $("a[href='#']").attr("href","javascript:;");

    //console.log("stickyHeader", props?.stickyHeader)
    if(props?.stickyHeader === false){

    } else{
      window.addEventListener("scroll", () => {
        setScroll(window.scrollY > 50)
      })
    }

    //window.scrollTo(0, 0)

    //console.log("props ==>", props)
    
  }, [])

  const data = useStaticQuery(graphql`
  query PrimaryMenuQueryCustom{
    glstrapi {

      socialLink {
        dropdown_menu_content {
          title
          show
          content
          button_cta{
            target
            theme
            label
            custom_link
            menu_item {
              slug
              parent {
                slug
                parent {
                  slug
                  parent {
                    slug
                  }
                }
              }
            }
          }
        }


        primary_menu {
          id
          menu_items {
            custom_link
            id
            label
            link_type
            target
            menu_item {
              slug
              parent {
                slug
                parent {
                  slug
                  parent {
                    slug
                  }
                }
              }
            }
          }
          sub_menu_item {
            custom_link
            id
            label
            link_type
            target
            menu_item {
              slug
              parent {
                slug
                parent {
                  slug
                  parent {
                    slug
                  }
                }
              }
            }
          }
        }
      }

      siteConfig {
        site_phone_no
      }
    }
  }`)

  var header_data = data.glstrapi;
  var dropdown_content = header_data?.socialLink?.dropdown_menu_content

  //console.log("header_data", dropdown_content)
  
  //console.log("search_icon_link", search_icon_link, header_data?.socialLink?.top_menu?.links)

  return (
    <React.Fragment>

      <header className={`${scroll ? " header header--fixed " : "header"} ${props?.GQLPage?.layout}`}>
        <Container >
          <Row>
            <Col>

              <Nav>
                <Navbar expand="xl">


                  <div className="navigation-wrap">
                    {defaultResult_Link && 
                      <Link to={`${defaultResult_Link}`} className="search d-xl-none"><i className="icon-search-mbl"></i></Link>
                    }

                    {(process.env.GATSBY_MYACCOUNT_URL && !process.env.GATSBY_MYACCOUNT_CUSTOM) && (
                      <Link to={`${process.env.GATSBY_MYACCOUNT_URL}`} className="sb-myacc d-xl-none" aria-label="myaccount">
                        <i className="icon-author"></i> <span className="d-none d-xl-flex">Sign in</span>
                      </Link>
                    )} 

                    {process.env.GATSBY_MYACCOUNT_CUSTOM && 
                      <Link to={process.env.GATSBY_MYACCOUNT_CUSTOM} className="sb-myacc custom_myacc  d-xl-none" aria-label="myaccount">
                        <i className="icon-author"></i> <span className="d-none d-xl-flex">Sign in</span>
                      </Link>
                    }

                    <Nav>
                      <HeaderMenu data={header_data?.socialLink?.primary_menu} dropdown_content={header_data?.socialLink?.dropdown_menu_content} />
                    </Nav>
                  </div>

                  {<HeaderLogo GQLPage={props?.GQLPage} scroll={scroll}/>}

                  {/* <div className="nav-right ml-auto d-none ">
                    <Link to={`/${PageLinks?.branch_finder}/`} className="btn btn-primary"><i className="icon-mobile"></i> Contact Us</Link>
                    <Button  className="btn btn-outline"  onClick={props.handlerClick} variant="link">
                      <i className="menu-icon"></i>  Menu
                    </Button>
                    <div className="hamburger-button d-md-none">
                      <Button className="menu-icon" onClick={props.handlerClick} variant="link">
                      </Button>
                    </div>
                  </div> */}


                  <div class="nav-item-right">
                    

                    {/* <Link to={`${search_icon_link[0]?.menu_items?.custom_link}`} className="search"><i className="icon-search"></i></Link> */}

                    {process.env.GATSBY_SITE_NAME === "Sinclair" ? 
                      <Link to={`/${PageLinks?.branch_finder}/`} className="phone_cls d-xl-none" aria-label="phone number">
                        <i className="icon-phone"></i>
                      </Link>
                      : header_data?.siteConfig?.site_phone_no &&
                      <Link to={`/${PageLinks?.branch_finder}/`} className="phone_cls d-xl-none" aria-label="phone number">
                        <i className="icon-phone"></i>
                      </Link>
                    }

                    {(process.env.GATSBY_MYACCOUNT_URL && !process.env.GATSBY_MYACCOUNT_CUSTOM) && (
                      <Link to={`${process.env.GATSBY_MYACCOUNT_URL}`} className="sb-myacc d-none d-xl-flex" aria-label="myaccount">
                        <i className="icon-author"></i> <span className="d-none d-xl-flex">Sign in</span>
                      </Link>
                    )} 

                    {process.env.GATSBY_MYACCOUNT_CUSTOM && 
                      <Link to={process.env.GATSBY_MYACCOUNT_CUSTOM} className="sb-myacc custom_myacc d-none d-xl-flex" aria-label="myaccount">
                        <i className="icon-author"></i> <span className="d-none d-xl-flex">Sign in</span>
                      </Link>
                    }

                    {/* <Link to={`/${PageLinks.request_valuation}/`} className="valuation_btn d-none d-md-flex">
                      Book a valuation 
                    </Link> */}
                    
                    <span className="sep"></span>

                    <div className="mobile-menu" onClick={props.handlerClick}> <i className="icon-mobile-lines" /> <span className="d-xl-flex d-none">Menu</span></div>
                  </div>
                </Navbar>
              </Nav>

            </Col>
          </Row>
        </Container>
      </header>


    </React.Fragment>
  )
}



export default PrimaryHeader